import { SentimentWordConfig } from './types';

export const itSentimentWordConfig: SentimentWordConfig = {
    positiveWords: new Set([
        'approvato',
        'attivo',
        'bene',
        'brillante',
        'calmo',
        'chiaro',
        'crescita',
        'eccellente',
        'efficace',
        'felice',
        'fiducia',
        'forte',
        'geniale',
        'gioia',
        'grande',
        'miglioramento',
        'migliorato',
        'ottimo',
        'perfetto',
        'positivo',
        'pronto',
        'progresso',
        'resolto',
        'risolto',
        'sano',
        'sicuro',
        'solido',
        'stabile',
        'successo',
        'utile',
        'valore',
        'vittoria',
        'aiuto',
        'amato',
        'apprezzato',
        'avanti',
        'calore',
        'celebrare',
        'comodo',
        'contento',
        'curato',
        'entusiasmo',
        'fatto',
        'fiducioso',
        'fluido',
        'fortuna',
        'gentile',
        'guadagno',
        'ispirante',
        'leggero',
        'migliore',
        'motivato',
        'ordine',
        'premio',
        'protetto',
        'sereno',
        'soddisfatto',
        'supportato',
        'vincente',
        'vivace',
        'accogliente',
        'affidabile',
        'aiutato',
        'allegro',
        'amichevole',
        'amore',
        'armonia',
        'benefico',
        'bravo',
        'capace',
        'compiuto',
        'conforto',
        'consistente',
        'coraggio',
        'disteso',
        'entusiasta',
        'equilibrio',
        'fidato',
        'gioioso',
        'integro',
        'leggerezza',
        'luminoso',
        'merito',
        'morbido',
        'ordinato',
        'piacevole',
        'rassicurante',
        'recuperato',
        'rinforzato',
        'sorriso',
        'speranza',
        'splendido',
        'stimolo',
        'tranquillita',
        'valido',
        'vantaggio',
        'verificato',
        'vigoroso',
        'vivo',
        'volentieri',
    ]),
    negativeWords: new Set([
        'ansia',
        'bloccato',
        'caos',
        'crisi',
        'debole',
        'declino',
        'difficile',
        'disastro',
        'dolore',
        'emergenza',
        'errore',
        'fallimento',
        'fallito',
        'frustrato',
        'grave',
        'insicuro',
        'lento',
        'male',
        'minaccia',
        'odio',
        'paura',
        'peggio',
        'pericolo',
        'problema',
        'regressione',
        'rifiutato',
        'rischio',
        'rotto',
        'terribile',
        'triste',
        'urgente',
        'allarme',
        'angoscia',
        'arrabbiato',
        'blocco',
        'caduta',
        'collasso',
        'complicato',
        'confuso',
        'critico',
        'danneggiato',
        'delusione',
        'depresso',
        'disordinato',
        'doloroso',
        'guasto',
        'imbarazzante',
        'instabile',
        'minaccioso',
        'nervoso',
        'ostacolo',
        'panico',
        'peggiore',
        'perdita',
        'pressione',
        'rallentato',
        'rotta',
        'scadente',
        'scontro',
        'stress',
        'tensione',
        'tossico',
        'urgenza',
        'vulnerabile',
        'vergogna',
        'abbattuto',
        'aggressivo',
        'allarmante',
        'amaro',
        'ansioso',
        'bloccante',
        'crollo',
        'debolezza',
        'deludente',
        'demoralizzato',
        'difettoso',
        'disagio',
        'dubbio',
        'falso',
        'ferito',
        'freddo',
        'inquietante',
        'instabilita',
        'inutile',
        'irritante',
        'malfunzionamento',
        'nocivo',
        'opprimente',
        'paura',
        'penoso',
        'perdita',
        'rosso',
        'rovina',
        'scoraggiante',
        'spento',
        'stressante',
        'trauma',
        'violento',
        'vulnerato',
        'malessere',
    ]),
};
